//custom hook
import { useQuery } from 'react-query'

export default function useQueryLpData(queryKey, URL) {

  return useQuery(queryKey, () =>
    fetch(URL).then(res =>
      res.json()
      , { refetchOnWindowFocus: false }
    ))
}
